const STANDARD_SIZE_ORDER = new Map(
  ["xxxs", "xxs", "xs", "s", "m", "l", "xl", "xxl", "xxxl"].map(
    (size, index) => [size, index],
  ),
);

const toNumber = (value) => {
  const parsedValue = parseFloat(value);
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

const normalizeSizeName = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .replace(/^(size|kich thuoc)\s*/i, "")
    .replace(/[\s_-]+/g, "");

export const getProductOptionPrice = (option) => {
  if (!option || typeof option !== "object") return toNumber(option);

  const promoPrice = toNumber(option.promo_price);
  return promoPrice > 0 ? promoPrice : toNumber(option.value);
};

export const compareSizeNames = (firstName, secondName) => {
  const normalizedFirst = normalizeSizeName(firstName);
  const normalizedSecond = normalizeSizeName(secondName);
  const firstStandardOrder = STANDARD_SIZE_ORDER.get(normalizedFirst);
  const secondStandardOrder = STANDARD_SIZE_ORDER.get(normalizedSecond);

  if (
    firstStandardOrder !== undefined &&
    secondStandardOrder !== undefined
  ) {
    return firstStandardOrder - secondStandardOrder;
  }
  if (firstStandardOrder !== undefined) return -1;
  if (secondStandardOrder !== undefined) return 1;

  return String(firstName || "").localeCompare(String(secondName || ""), "vi", {
    numeric: true,
    sensitivity: "base",
  });
};

export const sortOptionsByPriceAsc = (options = []) =>
  [...options].sort(
    (first, second) =>
      getProductOptionPrice(first) - getProductOptionPrice(second),
  );

export const sortSizeOptionsByPriceAsc = (options = []) =>
  [...options].sort((first, second) => {
    const priceDifference =
      getProductOptionPrice(first) - getProductOptionPrice(second);
    if (priceDifference !== 0) return priceDifference;

    return compareSizeNames(
      first?.name || first?.label || first?.value,
      second?.name || second?.label || second?.value,
    );
  });
